import type { FrontendWidget } from '../types';
import { CardExpandableComponent } from './CardExpandableComponent';
import type { CardExpandableConfig, CardExpandableResolved } from './types';

/**
 * Sub-component of the Flexible Content Card, never offered as a page-level
 * block (it is not in any Strapi dynamic zone). It still needs a registry
 * entry: it is a **lookup** widget — `CardExpandableResolver` loads the
 * referenced Content Snippet server-side — so `SlotRenderer` has to find a
 * component for it and `blockRegistry` has to hand it the resolved data.
 *
 * No `resolveSync` for that same reason.
 */
export const cardExpandableWidget: FrontendWidget<
  CardExpandableConfig,
  CardExpandableResolved
> = {
  componentType: 'widgets.card-expandable',
  displayName: 'Card Expandable',
  ComponentA: CardExpandableComponent,
};
